import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {DialogService} from "../services/dialog.service";

@Component({
  selector: 'micro-service-multiselect',
  templateUrl: './service-multiselect.component.html'
})
export class ServiceMultiSelectComponent implements OnInit, OnChanges  {
  services:any[];

  @Output()
  selectedServicesChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  selectedServices:string[];

  @Input()
  companyId:any;

  helpCallback(component) {
    component.dialogService.openHelp({context: 'service', companyId: this.companyId});
  }

  onNgModelChange(e) {
    this.selectedServicesChange.emit(e);
  }

  constructor(private env:EnvService, private http:HttpClient, private dialogService:DialogService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'companyId') {
        this.reload();
      }
    }
  }

  ngOnInit() {
    if (!this.companyId) {
      this.reload();
    }
  }

  reload() {
    let params:HttpParams = new HttpParams();
    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }

    this.http.get(`${this.env.e.url}/auth/services`, {params:params}).subscribe(
      data => {
        this.services = data as any[];
      }
    );
  }
}
